var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCircleLw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #08191f;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #e1f000;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HG"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.000006351889169,
    y: 0.000017557409592,
    width: 32,
    height: 31.999968376840116
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "White_and_lime",
    "data-name": "White and lime"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,4c-6.62744140625,0-12,5.37255859375-12,12s5.37255859375,12,12,12,12-5.37255859375,12-12-5.37255859375-12-12-12ZM16,26c-5.513916015619543,0-10-4.485961914060681-10-10s4.486083984380457-10,10-10c5.513916015630457,0,10,4.485961914060681,10,10s-4.486083984369543,10-10,10Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "17 10.5 15 10.5 15 15 10.5 15 10.5 17 15 17 15 21.5 17 21.5 17 17 21.5 17 21.5 15 17 15 17 10.5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleLw);
export default __webpack_public_path__ + "static/media/Plus_circle_LW.dfcee34d.svg";
export { ForwardRef as ReactComponent };